import React, { useState, useGlobal } from "reactn";
import PropTypes from "prop-types";

// components
import PageText from "../../../_common/pageText/PageText.styled";

// styled components
import { PaymentOptionStyled } from "./PaymentOption.styled";
import ContainerBox from "../../../_common/containers/ContainerBox";
import SpaceBetweenContainer from "../../../_common/containers/SpaceBetweenContainer";

const PaymentOption = ({ title, form }) => {
    const [blockSummary, setBlockSummary] = useState(true);

    const [values] = useGlobal("values");

    const editBlock = () => {
        // show editableFields
        setBlockSummary(false);
    };

    const saveBlock = () => {
        setBlockSummary(true);
    };
    return (
        <PaymentOptionStyled>
            <PageText>{title}</PageText>
            <ContainerBox>
                <SpaceBetweenContainer>
                    {values.paymentOption === "continuousDebit" ? (
                        <PageText>Continuous Debit Authority</PageText>
                    ) : (
                        <>
                            <PageText>Top-up: €{values.topUpValue}.00</PageText>
                            <input type="hidden" name="topUpValue" value={values.topUpValue} />
                        </>
                    )}

                    <div className="iconWrapper">
                        {blockSummary ? (
                            <SpaceBetweenContainer onClick={editBlock}>
                                <span className="icon edit-green"></span>
                                <p className="icon-text">Edit</p>
                            </SpaceBetweenContainer>
                        ) : (
                            <SpaceBetweenContainer onClick={saveBlock}>
                                <span className="icon save-green" onClick={saveBlock}></span>
                                <p className="icon-text">Save</p>
                            </SpaceBetweenContainer>
                        )}
                    </div>
                </SpaceBetweenContainer>
            </ContainerBox>
            {!blockSummary && <>{form}</>}
        </PaymentOptionStyled>
    );
};

export default PaymentOption;

// props
PaymentOption.propTypes = {
    title: PropTypes.string,
    form: PropTypes.any
};
